import React, { useEffect, useState } from 'react';
import './FillInTheBlanks.css';

const FillInTheBlanks = ({ id, className, InputValue = '', initialValue = "", onChange }) => {
  const placeholder = '{{input_box}}';
  const segments = InputValue.split(placeholder);
  const [inputs, setInputs] = useState(Array(segments.length - 1).fill(''));
  const [previewText, setPreviewText] = useState('');

  const handleInputChange = (index, value, blur) => {
    const updatedInputs = [...inputs];
    updatedInputs[index] = !blur ? value : value.trim();
    setInputs(updatedInputs);

    const combined = segments.reduce((acc, part, i) => {
      return acc + part + (updatedInputs[i] || '');
    }, '');

    const cleaned = combined.replace(/\.{2,}/g, '.');
    setPreviewText(cleaned);

    if (onChange) {
      onChange(cleaned);
    }
  };

  useEffect(() => {
    if (initialValue.trim() && segments.length) {
      let strCopy = initialValue;
      let varArray = [];
      segments.forEach((ele) => {
        if (strCopy.indexOf(ele) === 0) {
          strCopy = strCopy.replace(ele, "");
        } else {
          varArray.push(strCopy.slice(0, strCopy.indexOf(ele)));
          strCopy = strCopy.replace(varArray[varArray.length - 1], "");
          strCopy = strCopy.replace(ele, "");
        }
      });
      if (strCopy.trim())
        varArray.push(strCopy);

      if (varArray.length === inputs.length) {
        setInputs(varArray.map(ele => ele !== placeholder ? ele : ""));
        const combined = segments.reduce((acc, part, i) => {
          return acc + part + (varArray[i] || '');
        }, '');
        setPreviewText(combined.replace(/\.{2,}/g, '.'));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValue]);

  return (
    <div id={id} className={className} style={{ marginBottom: "20px" }}>
      {segments.map((text, i) => (
        <span key={`segment-${i}`}>
          {text}
          {i < inputs.length && (
            <input
              type="text"
              autoComplete="off"
              spellCheck={false}
              className="fitb-input"
              value={inputs[i]}
              onChange={(e) => handleInputChange(i, e.target.value, false)}
              onBlur={(e) => handleInputChange(i, e.target.value, true)}
              onCopy={(e) => e.preventDefault()}
              onPaste={(e) => e.preventDefault()}
              onCut={(e) => e.preventDefault()}
              onContextMenu={(e) => e.preventDefault()}
            />
          )}
        </span>
      ))}

      <div className="fitb-preview" style={{ marginTop: "16px", fontStyle: "italic", color: "#555" }}>
        <strong>Preview:</strong> {previewText || "Your input will appear here..."}
      </div>
    </div>
  );
};

export default FillInTheBlanks;
